module.exports = __webpack_public_path__ + "static/img/ICON02@2x.7d0d345.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ICON02@2x.png
// module id = UFnK
// module chunks = 1